import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import { WorkOrder } from "../type/WorkOrder";
import { fetcher, Pagination, PaginationResponse } from "@/shared/core-configs";
import { API } from "@/config";

export const GET_WORK_ORDERS_FETCH_KEY = "GET_WORK_ORDERS";

export type WorkOrderStatus = "open" | "closed";

export type WorkOrderFilters = {
  status?: WorkOrderStatus;
  clientEntityId?: string;
  dateFrom?: string;
  dateTo?: string;
};

type GetWorkOrdersParams = {
  zoneIds?: string[] | string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
  filters?: WorkOrderFilters;
} & Partial<Pagination>;

export const getWorkOrder = async (
  zoneIds?: string[] | string,
  page?: number,
  pageSize?: number,
  showDisabled = false,
  searchTerm?: string,
  sort?: string,
  order?: string,
  filters?: WorkOrderFilters,
) => {
  const params = qr.stringify({
    zoneIds,
    pageSize,
    page,
    showDisabled,
    searchTerm,
    sort,
    order,
    ...filters,
  });
  const response = await fetcher.get(`${API.GESLUB}/workOrders?${params}`);
  return response.data;
};

export const useGetWorkOrder = ({
  zoneIds,
  page,
  pageSize,
  showDisabled,
  searchTerm,
  sort,
  order,
  filters,
}: GetWorkOrdersParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<WorkOrder>,
    Error
  >({
    queryKey: [
      GET_WORK_ORDERS_FETCH_KEY,
      zoneIds,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      sort,
      order,
      filters,
    ],
    queryFn: () =>
      getWorkOrder(
        zoneIds,
        page,
        pageSize,
        showDisabled,
        searchTerm,
        sort,
        order,
        filters,
      ),
    placeholderData: (prev) => prev,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
